
export const REACT_APP_API_BASE_URL = process.env.REACT_APP_LOCAL_API_URL || 'https://admin.inrise.in/';
export const wsUrl = process.env.REACT_APP_LOCAL_WS_URL || "admin.inrise.in";
export const REACT_APP_STRATEGY_ENGINE_URL = process.env.REACT_APP_LOCAL_STRATEGY_URL || 'https://admin.inrise.in/strategy-api/';